import {
    FormControl,
    FormLabel,
    Input,
    Text,
    Button,
    VStack,
    useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import axios from "axios";
import { FormConsentFields } from "../../FormConsent/FormConsent";

export default function FormApplication(props) {
    const toast = useToast();
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [text, setText] = useState("");
    const [consentPd, setConsentPd] = useState(false);
    const [consentOferta, setConsentOferta] = useState(false);
    const [consentMarketing, setConsentMarketing] = useState(false);
    const [showConsentError, setShowConsentError] = useState(false);
    const [formError, setFormError] = useState("");

    const submit = async () => {
        if (!consentPd) {
            setFormError(
                "Необходимо дать согласие на обработку персональных данных"
            );
            setShowConsentError(true);
            return;
        }
        if (!consentOferta) {
            setFormError("Необходимо принять условия публичной оферты");
            setShowConsentError(true);
            return;
        }
        setFormError("");
        setShowConsentError(false);
        if (name.length < 2 || phone.length < 10) {
            toast({
                position: "bottom",
                title: `Введите корректные данные!`,
                status: "warning",
                isClosable: true,
            });
            return;
        }
        await axios.post("https://api.twodev.cc/helper/septiki", {
            city: props.city.text ? props.city.text : props.city,
            info: `Главная страница; последняя форма; текст: ${text}; маркетинг: ${consentMarketing}`,
            name: name,
            phone: phone,
        });
        toast({
            position: "bottom",
            title: `Заявка отправлена!`,
            status: "success",
            isClosable: true,
        });
    };

    return (
        <VStack w="100%" mt="5px">
            <Text p="20px" fontSize={20} fontFamily="Hero">
                Остались вопросы? Оставьте заявку и мы свяжемся с Вами!
            </Text>
            <FormControl w="90%">
                <FormLabel fontFamily="Hero" fontSize={19}>
                    Ваше Имя
                </FormLabel>
                <Input
                    type="text"
                    border="solid 2px white"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <FormLabel fontFamily="Hero" fontSize={19} mt={2}>
                    Ваш номер
                </FormLabel>
                <Input
                    type="tel"
                    placeholder="+7 (986) 543-21-00"
                    border="solid 2px white"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <FormLabel fontFamily="Hero" fontSize={19} mt={2}>
                    Текст
                </FormLabel>
                <Input
                    type="text"
                    border="solid 2px white"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
            </FormControl>
            <VStack spacing="10px" w="90%">
                <FormConsentFields
                    theme="light"
                    consentPd={consentPd}
                    setConsentPd={setConsentPd}
                    consentOferta={consentOferta}
                    setConsentOferta={setConsentOferta}
                    consentMarketing={consentMarketing}
                    setConsentMarketing={setConsentMarketing}
                    showConsentError={showConsentError}
                    formError={formError}
                    onClearError={() => {
                        setFormError("");
                        setShowConsentError(false);
                    }}
                />
                <Button
                    w="100%"
                    h="45px"
                    colorScheme="yellow"
                    color="white"
                    isDisabled={!consentPd || !consentOferta}
                    onClick={submit}
                >
                    Оформить заявку
                </Button>
                <Button w="100%" h="45px" colorScheme="orange" color="white">
                    Позвонить менеджеру
                </Button>
            </VStack>
        </VStack>
    );
}
